import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { AuthProvider } from "@context/AuthContext";
import { NavigationProvider } from "@context/NavigationContext";
import { UIProvider } from "@context/UIContext";
import Navigation from "@features/navigation";

import SophiaStorefrontPage from "./SophiaStorefrontPage";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/sophia-lan-storefront" replace={true} />} />
      <Route path="/sophia-lan-storefront" element={<SophiaStorefrontPage />} />
      <Route path="*" element={<Navigate to="/sophia-lan-storefront" replace={true} />} />
    </Routes>
  );
};

const AppContext = ({ children }) => {
  return (
    <UIProvider>
      <NavigationProvider>
        <AuthProvider>{children}</AuthProvider>
      </NavigationProvider>
    </UIProvider>
  );
};

function App() {
  return (
    <Router>
      <AppContext>
        <Navigation>
          <AppRoutes />
        </Navigation>
      </AppContext>
    </Router>
  );
};

export default App;
